
import { React, useState, useEffect, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
//import { Helmet } from 'react-helmet';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dialog, Transition } from '@headlessui/react'
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';





const Orders = () => {
    const [datas, setdatas] = useState([]);
    const [summary, setsummary] = useState([]);
    // const token = localStorage.getItem('logintoken');
    const token = Cookies.get('token');
    const currentdomain = window.location.origin.split(':3000')[0];

    const urla = `${currentdomain}/bk/get_orders.php`;
    const url_summary = `${currentdomain}/bk/summary.php`;
    const url_state = `${currentdomain}/bk/order_change_state.php`;


    const [refrach, setrefrach] = useState(0);
    const [ordrby, setordrby] = useState(false);



    const [selectedItems, setSelectedItems] = useState([]);

    // for paginaionnnnn *********************************

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(50);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = datas.slice(indexOfFirstItem, indexOfLastItem);
    const [ispagination, setispagination] = useState(false);
    const [deleteId, setdeleteId] = useState(0);

    const [editname, seteditname] = useState("");
    const [editphone, seteditphone] = useState("");
    const [editprice, seteditprice] = useState(0);
    const [editpricedelv, seteditpricedelv] = useState(0);
    const [editprovince_id, seteditprovince_id] = useState(1);
    const [editadress, seteditadress] = useState("");
    const [editdate, seteditdate] = useState("");

    const [orderday, setorderday] = useState(0);
    const [orderyday, setorderyday] = useState(0);
    const [orderweek, setorderweek] = useState(0);
    const [ordermonth, setordermonth] = useState(0);
    const [orderall, setorderall] = useState(0);

    const [orderday_total, setorderday_total] = useState(0);
    const [orderyday_total, setorderyday_total] = useState(0);
    const [orderweek_total, setorderweek_total] = useState(0);
    const [ordermonth_total, setordermonth_total] = useState(0);
    const [orderall_total, setorderall_total] = useState(0);
    const [multi, setmulti] = useState(0);
    const navigate = useNavigate();



    const paginate = (pageNumber) => {
        //setrefrach(refrach+1);
        setCurrentPage(pageNumber);

    };

    const startIndex = (currentPage - 1) * itemsPerPage;


    const table = 'orders';
    //**************end pagination***********************/

    let [isOpen, setIsOpen] = useState(false)
    let [isOpenEdit, setisOpenEdit] = useState(false)
    function closeModal() {
        setIsOpen(false)
        setisOpenEdit(false)
    }
    function yesmodel(multi) {
        setIsOpen(false);
        (multi === 0) ? delete_order(deleteId) : delete_multi_order(selectedItems);

    }
    function savemodel() {
        setisOpenEdit(false);
        edit_order();

    }


    function openModal(client_id) {
        setmulti(0);
        setdeleteId(client_id);
        setIsOpen(true);
    }
    function openMultiModal() {
        setmulti(1);
        setIsOpen(true);
    }

    function OpenOnEdit(client_id, name, phone, price, pricedel, province_id, adress, dates) {
        setdeleteId(client_id);
        seteditname(name);
        seteditphone(phone);
        seteditprice(price);
        seteditpricedelv(pricedel);
        seteditprovince_id(province_id);
        seteditadress(adress);
        seteditdate(dates)
        setisOpenEdit(true)
    }

    const showToastMessageSuccus = () => {
        toast.success("! تمت العملية بنجاح ", {
        });
    };
    const showToastMessageError = () => {
        toast.error("!حدث خطأ فشل العملية", {
        });
    };


    function sortByDate() {

        const sortedData = ordrby ? [...datas].sort((a, b) => (new Date(b.date)) - new Date(a.date)) : [...datas].sort((a, b) => (new Date(a.date)) - new Date(b.date));
        setordrby(!ordrby);
        setdatas(sortedData);
    };

    function sortByPrice() {
        const sortedData = ordrby ? [...datas].sort((a, b) => (parseInt(b.selling_price)) - (parseInt(a.selling_price))) : [...datas].sort((a, b) => (parseInt(a.selling_price)) - (parseInt(b.selling_price)));
        setordrby(!ordrby);
        setdatas(sortedData);
    };

    function sortByWilaya() {

        const sortedData = ordrby ? [...datas].sort((a, b) => (parseInt(b.province_id)) - (parseInt(a.province_id))) : [...datas].sort((a, b) => (parseInt(a.province_id)) - (parseInt(b.province_id)));
        setordrby(!ordrby);
        setdatas(sortedData);
    };

    function sortByProduct() {
        const sortedData = ordrby ? [...datas].sort((a, b) => (parseInt(b.product_id)) - (parseInt(a.product_id))) : [...datas].sort((a, b) => (parseInt(a.product_id)) - (parseInt(b.product_id)));
        setordrby(!ordrby);
        setdatas(sortedData);
    };

    function checkboxHandler(e) {
        let isSelected = e.target.checked;
        let value = e.target.value;

        if (isSelected) {
            setSelectedItems([...selectedItems, value]);

        } else {
            setSelectedItems((prevData) => {
                return prevData.filter((id) => {
                    return id !== value;
                })
            })

        }

    }
    //datee*******************************************************
    function calculateTimeDifference(data) {
        if (data == null) return 'Loading...';
        const databaseDate = new Date(data);
        const currentDate = new Date();
        const timeDifference = currentDate - databaseDate;
        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);
        const months = Math.floor(currentDate.getMonth() - databaseDate.getMonth() + (12 * (currentDate.getFullYear() - databaseDate.getFullYear())));
        const years = Math.floor(currentDate.getFullYear() - databaseDate.getFullYear());

        if (years > 0) {
            return `منذ ${years} ${years === 1 ? 'سنة' : 'سنوات'}`;
        } else if (months > 0) {
            return `منذ ${months} ${months === 1 ? 'شهر' : 'أشهر'}`;
        } else if (weeks > 0) {
            return `منذ ${weeks} ${weeks === 1 ? 'اسبوع' : 'أسابيع'}`;
        }
        if (days > 0) {
            return `منذ ${days}  ${days === 1 ? 'يوم' : 'أيام'} `;
        } else if (hours > 0) {
            return `منذ ${hours}  ${hours === 1 ? 'ساعة' : 'ساعات'}`;
        } else if (minutes > 0) {
            return `منذ ${minutes} ${minutes === 1 ? 'دقيقة' : 'دقائق'} `;
        } else {
            return 'منذ قليل';
        }
    };
    //datee*******************************************************
    function checkAllHandler() {


        if (currentItems.length === selectedItems.length) {
            setSelectedItems([]);
        } else {
            const postIds = currentItems.map((item) => {
                return item.client_id;
            })

            setSelectedItems(postIds);
        }
    }



    async function delete_order(client_id) {

        try {
            const response = await fetch(`${currentdomain}/bk/delete_order.php`, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'text/html',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ client_id }),
            });

            if (!response.ok) {
                showToastMessageError()
                throw new Error('Network response was not ok');

            }

            const data = await response.json();
            ((parseInt(data.success)) === 1) ? showToastMessageSuccus() : showToastMessageError();
            setrefrach(refrach + 1);
        } catch (error) {
            showToastMessageError()
            console.error('Error:', error);
        }

    }



    async function edit_order() {

        try {
            const response = await fetch(`${currentdomain}/bk/edit_order.php`, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'text/html',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ deleteId, editname, editphone, editprice, editpricedelv, editprovince_id, editadress }),
            });

            if (!response.ok) {
                showToastMessageError()
                throw new Error('Network response was not ok');

            }

            const data = await response.json();
            (parseInt(data.success) === 1) ? showToastMessageSuccus() : showToastMessageError();
            setrefrach(refrach + 1);
        } catch (error) {
            showToastMessageError()
            console.error('Error:', error);
        }

    }


    async function delete_multi_order(ids) {

        try {
            const response = await fetch(`${currentdomain}/bk/delete_order.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ ids: ids }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');

            }

            //   console.log('success multi ids ' + JSON.stringify({ ids: ids }));
            const data = await response.json();
            setSelectedItems([]);
            (parseInt(data.success) === 1) ? showToastMessageSuccus() : showToastMessageError();
            setrefrach(refrach + 1);
        } catch (error) {
            showToastMessageError()
            console.error('Error:', error);

        }

    }

    const handleChangePagination = event => {
        setCurrentPage(1);
        Cookies.set("pagination_orders", event.target.value)
        setitemsPerPage((event.target.value));
    };
    // const HandleChangestateHead = event => {
    //     // setitemsPerPage((event.target.value));
    //     // const sortedData = ordrby ? [...datas].sort((a, b) => (parseInt(b.product_id)) - (parseInt(a.product_id))) : [...datas].sort((a, b) => (parseInt(a.product_id)) - (parseInt(b.product_id)));
    //     // setordrby(!ordrby);

    //     const sortedData = [...datas].find((item) => item.state === parseInt(event.target.value));

    //     console.log(sortedData)
    //     setdatas(sortedData);
    // };

    const handlechangestate = async (event, client_id) => {
        //  alert(event.target.value + ' ggggggggggggg ' + client_id)

        let stata = event.target.value;

        try {
            const response = await fetch(url_state, {
                method: 'POST',
                headers: {

                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ client_id, stata }),
            });

            if (!response.ok) {
                showToastMessageError()
                throw new Error('Network response was not ok');

            }
            const data = await response.json();
            (parseInt(data.success) === 1) ? showToastMessageSuccus() : showToastMessageError();
            setrefrach(refrach + 1);

        } catch (error) {
            showToastMessageError()
            console.error('StataaaaaaaaaaError:', error);
            //  alert(prod_id + hide_state);
            // console.log(JSON.stringify({ prod_id, hide_state }));
        }
    }

    useEffect(

        function () {
            async function fetchSummury() {

                try {
                    const response = await fetch(url_summary, {
                        method: 'POST',
                        headers: {
                            // 'Content-Type': 'text/html',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({ table }),
                    });

                    if (!response.ok) {
                        throw new Error('Network response was not ok');

                    }

                    console.log('success bbbbbbbbbbbbb');
                    const data = await response.json();
                    //   setdatas(data.customer);

                    if (data.success === 1) {
                        setsummary(data.datas);
                    }
                    else if (data.success === 2) {
                        // alert(data.datas)
                        if (Cookies.get('token')) {
                            Cookies.remove('token');
                        }
                        navigate('/auth/', { replace: true });
                    }
                    else {
                        // alert(data.datas)
                    }


                } catch (error) {
                    console.error('Error:', error);
                }

            }
            async function fetchData() {

                try {
                    const response = await fetch(urla, {
                        method: 'POST',
                        headers: {
                            // 'Content-Type': 'text/html',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({ table }),
                    });

                    if (!response.ok) {
                        throw new Error('Network response was not ok');

                    }

                    console.log('success');
                    const data = await response.json();
                    // setdatas(data.customer);
                    // fetchSummury();

                    if (data.success === 1) {
                        setdatas(data.datas.customer)
                        fetchSummury();
                    }
                    else if (data.success === 2) {
                        // alert(data.datas)
                        navigate('/auth/', { replace: true });
                    }
                    else {
                        alert(data.datas)
                    }

                } catch (error) {
                    console.error('Error:', error);
                }

            }

            fetchData();
            document.title = 'الطلبيات';
            // eslint-disable-next-line
        }, [refrach, url_summary, urla]
    );


    useEffect(
        function () {
            try {

                setorderday(summary[0]['days']);
                setorderday_total(summary[0]['totals']);
                setorderyday(summary[1]['yday']);
                setorderyday_total(summary[1]['totals']);
                setorderweek(summary[2]['weeks']);
                setorderweek_total(summary[2]['totals']);
                setordermonth(summary[3]['months']);
                setordermonth_total(summary[3]['totals']);
                setorderall(summary[4]['all']);
                setorderall_total(summary[4]['totals']);
            }
            catch (e) { }
        }, [summary]
    );
    useEffect(

        function () {
            if (Cookies.get('pagination_orders')) { setitemsPerPage(Cookies.get('pagination_orders')) }
            else { setitemsPerPage(50) }

            ((Math.ceil(datas.length / itemsPerPage)) > 1) ? setispagination(true) : setispagination(false);

        }, [itemsPerPage, datas]
    );

    useEffect(
        //uncheck box when switch page
        function () {
            setSelectedItems([]);
            console.log(currentPage);
        }, [currentPage]
    );








    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta name="viewport" content={'width=1024'} />
                </Helmet>
            </HelmetProvider>

            <div className="resume grid grid-cols-7 gap-4 mx-3 mt-11 text-center text-white font-bold text-lg lgg:px-36">
                <div className="h-[110px] rounded-xl bg-blue-500">
                    <ul className="p-2">
                        <li className="text-xl mb-1">اليوم</li>
                        <li className="">({orderday}) طلبية</li>
                        <li className="tracking-wider text-xl">{orderday_total} دج</li>

                    </ul>
                </div>
                <div className="h-[110px] rounded-xl bg-orange-300">
                    <ul className="p-2">
                        <li className="text-xl mb-1">الأمس</li>
                        <li>({orderyday}) طلبية </li>
                        <li className="tracking-wider text-xl">{orderyday_total} دج</li>
                    </ul>
                </div>
                <div className="h-[110px] rounded-xl bg-green-500">
                    <ul className="p-2">
                        <li className="text-xl mb-1">الأسبوعي</li>
                        <li>({orderweek}) طلبية </li>
                        <li className="tracking-wider text-xl">{orderweek_total} دج</li>


                    </ul>
                </div>
                <div className="h-[110px] rounded-xl bg-red-500">
                    <ul className="p-2">
                        <li className="text-xl mb-1">الشهري</li>
                        <li>({ordermonth}) طلبية </li>
                        <li className="tracking-wider text-xl">{ordermonth_total} دج</li>
                    </ul>
                </div>
                <div className="h-[110px] rounded-xl bg-purple-500 col-span-2">
                    <ul className="p-2">
                        <li className="text-xl mb-1">الكل</li>
                        <li>({orderall}) طلبية </li>
                        <li className="tracking-wider text-xl">{orderall_total} دج</li>
                    </ul>
                </div>

            </div>
            <div className="contanet mb-11 mt-6 w-full px-3">

                {/* <div className="grid grid-cols-12 h-14 mb-3"> */}
                <table className="flex justify-center text-sm">
                    <tr>

                        <td>
                            <select name="state" onChange={handleChangePagination} className="trie my-3 h-8  w-28 text-center   border-solid border-2  border-gray-200  focus:outline-none font-semibold  rounded-lg bg-gray-50 dark:bg-gray-800 dark:text-white" required >
                                <option value="5">5</option>
                                <option value="10" >10</option>
                                <option value="20">20</option>
                                <option value="50" selected>{itemsPerPage}</option>
                                <option value="100">100</option>
                            </select>
                        </td>
                        <td>
                            <div className={`orderbt flex justify-center m-4 h-8 w-24  font-bold  rounded-sm  ${(selectedItems.length === 0) ? 'text-black bg-gray-400 opacity-25 dark:text-white' : 'text-white bg-green-600    active:bg-yellow-400 cursor-pointer'}`} onClick={() => openMultiModal()}><button disabled={(selectedItems.length === 0)}>حذف {'(' + selectedItems.length + ')'} </button></div>

                        </td>
                        <td>
                            <select name="state" onChange={'HandleChangestateHead'} className="name my-3    h-8  w-28 text-center   border-solid border-2  border-gray-200  focus:outline-none font-semibold  rounded-lg bg-gray-50 dark:bg-gray-800 dark:text-white" required >
                                <option value="0" selected>ترتيب</option>
                                <option value="1">مؤجلة</option>
                                <option value="2">قيد التوصيل</option>
                                <option value="3">ملغاة</option>
                            </select>
                        </td>


                    </tr>
                </table>

                {/* </div > */}
                <div className="bb border border-gray-300  ">

                    <ul className="bg-gray-200 dark:bg-gray-800 dark:text-white  h-11 grid grid-cols-9 pt-2 text-lg font-bold">
                        <li>
                            <div className="flex items-center mt-1 ms-12">
                                <input id="default-checkbox" type="checkbox" checked={currentItems.length === selectedItems.length} onClick={() => checkAllHandler()} onChange={e => { }} className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500  focus:ring-2 " />
                                <div className="ms-2 px-3 pb-1 cursor-pointer" onClick={() => sortByProduct()}>
                                    منتج
                                </div>
                            </div>

                        </li>

                        <li className="me-16">
                            <div>
                                الاسم
                            </div>

                        </li>
                        <li className="me-11 line-clamp-1">
                            <div>
                                رقم الهاتف
                            </div>

                        </li>
                        <li className="me-16">
                            <div className="cursor-pointer" onClick={() => sortByPrice()}>
                                السعر
                            </div>

                        </li>
                        <li>
                            <div className="cursor-pointer me-16" onClick={() => sortByWilaya()}>
                                الولاية
                            </div>

                        </li>
                        <li className="me-11">
                            <div>
                                العنوان
                            </div>

                        </li>
                        <li>
                            <div className="cursor-pointer me-3 line-clamp-1" onClick={() => sortByDate()} >
                                تاريخ الطلب
                            </div>

                        </li>



                        <li>
                            <div>
                                الاجراءات
                            </div>

                        </li>
                        <li>
                            <div>
                                الحالة
                            </div>

                        </li>
                    </ul>
                </div>
                {/* {Array.from({ length: 5 }, (_, index) => ( */}

                {/* {datas.map((item, index) => ( */}
                {/* //       {[...datas].reverse().map((item, index) => ( */}
                {currentItems.map((item, index) => (

                    < div key={index} className="bb border-b border-s border-e border-gray-300  " >
                        <ul className={` ${(index % 2 === 0) ? 'bg-white dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-700'} dark:text-white hover:bg-green-100 hover:dark:bg-green-900 h-16 grid grid-cols-9 pt-3 text-start`}>
                            <li>
                                <div className="flex items-start text-center ms-2">
                                    <span className="me-5">{"(" + (startIndex + index + 1) + ')'}</span>
                                    <input id="default-checkbox" type="checkbox" checked={selectedItems.includes(item.client_id)} value={item.client_id} onChange={(e) => checkboxHandler(e)} className="w-4 h-4 me-3 cursor-pointer text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500  focus:ring-2 " />
                                    <Link key={index + 10} to={'/product/' + (item.title_id)} target="_blank">
                                        <img className="h-14 w-14 pb-2" src={item.img_default} alt="" />
                                    </Link>

                                </div>

                            </li>
                            <li>

                                <div className="line-clamp-2 w-32 font-semibold">
                                    {item.client_name}
                                </div>

                            </li>
                            <li>
                                <div className="items-center text-start mt-2 font-semibold text-sm">
                                    {item.phone}
                                </div>

                            </li>
                            <li>
                                <div className="items-center text-start  ms-6  font-semibold ">

                                    <ul>
                                        <li className="text-blue-400">
                                            {item.selling_price}
                                        </li>
                                        <li className="text-green-400">
                                            {item.selling_ship_price + "+"}
                                        </li>
                                    </ul>
                                </div>

                            </li>
                            <li>
                                <div className="items-center text-start mt-2 font-semibold text-sm">
                                    {item.province_name}
                                </div>

                            </li>
                            <li>
                                <div className="items-center text-start line-clamp-2 mt-2 ms-2 font-semibold text-sm">
                                    {item.address}
                                </div>

                            </li>
                            <li>
                                <div className="items-center text-start mt-2 font-semibold text-sm">
                                    {calculateTimeDifference(item.date)}
                                </div>

                            </li>



                            <li>
                                <div className="cursor-pointer grid grid-cols-4   items-center text-center ">

                                    <div className="icon rounded-full bg-gray-200 dark:bg-gray-800 cursor-pointer my-2 mx-2" onClick={() => OpenOnEdit(item.client_id, item.client_name, item.phone, item.selling_price, item.selling_ship_price, item.province_id, item.address, item.date)} >
                                        <FontAwesomeIcon icon={faPen} />
                                    </div>
                                    <div>

                                        <div className="icon rounded-full bg-gray-200 dark:bg-gray-800 cursor-pointer mx-1 my-2" onClick={() => openModal(item.client_id)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </div>


                                    </div>



                                </div>

                            </li>
                            <li>
                                <div className="me-6">
                                    <select name="state" defaultValue={item.state} onChange={(e) => handlechangestate(e, item.client_id)} className="name   w-18   border-solid border-2  border-gray-200  focus:outline-none font-semibold  rounded-lg bg-gray-50 dark:bg-gray-800 dark:text-white" required >
                                        <option value="0"></option>
                                        <option value="1">مؤجلة</option>
                                        <option value="2">قيد التوصيل</option>
                                        <option value="3">ملغاة</option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>
                ))}
                {/* ***************************pagination ******************************************************** */}
                <div className="flex justify-center" >
                    {ispagination &&
                        <nav aria-label="Page navigation example" className="text-center mt-8 ms-11">
                            <ul className="flex items-center -space-x-px h-8 text-sm ">
                                <li className={`${(currentPage > 1) ? 'cursor-pointer' : 'invisible'}`} onClick={() => ((currentPage > 1) && paginate(currentPage - 1))}>
                                    <div className="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 ">
                                        <svg className="w-2.5 h-2.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1 1 5l4 4" />
                                        </svg>
                                    </div>
                                </li>




                                {Array.from({ length: Math.ceil(datas.length / itemsPerPage) }).map((_, index) => (

                                    <li key={index + 1} onClick={() => (paginate(index + 1))}>
                                        <button className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500  border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${(currentPage === (index + 1)) ? 'bg-green-400 text-white hover:bg-green-400 hover:text-white' : 'bg-white text-gray-700'}`}> {index + 1}</button>
                                    </li>

                                ))}


                                <li className={`${(currentPage < Math.ceil(datas.length / itemsPerPage)) ? 'cursor-pointer' : 'invisible'}`} onClick={() => ((currentPage < Math.ceil(datas.length / itemsPerPage)) && paginate(currentPage + 1))}>
                                    <div className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700">

                                        <svg className="w-2.5 h-2.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4" />
                                        </svg>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    }
                </div>

                <ToastContainer position="bottom-right" />
                {/* yessssssssssssssssssssssssssssssss no   ENNNNNNNNNNNNNNND*/}
                <Transition appear show={isOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={closeModal}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black/25" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-normal leading-6 text-gray-900 text-center"
                                        >

                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-lg font-bold text-black text-center">
                                                هل تريد حذف الطلب؟
                                            </p>
                                        </div>

                                        <div className="mt-4 flex justify-between">
                                            <button
                                                type="button"
                                                className="inline-flex justify-center rounded-md border border-transparent bg-green-300 px-11 py-2 ms-11 text-sm font-medium text-white hover:bg-green-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                                                onClick={() => yesmodel(multi)}
                                            >
                                                نعم
                                            </button>
                                            <button
                                                type="button"
                                                className="inline-flex justify-center rounded-md border border-transparent bg-red-300 px-11 py-2  me-11 text-sm font-medium text-white hover:bg-red-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                                                onClick={closeModal}
                                            >
                                                لا
                                            </button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition >
                {/* yessssssssssssssssssssssssssssssss no   ENNNNNNNNNNNNNNND*/}


                <Transition appear show={isOpenEdit} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={closeModal}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black/25" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-normal leading-6 text-gray-900 text-center"
                                        >

                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-lg font-bold text-blue-400 text-center">
                                                تعديل معلومات الزبون

                                            </p>
                                        </div>
                                        <div className="text-center">
                                            <input id="name" name="name" defaultValue={editname} onChange={(event) => seteditname(event.target.value)} className="name p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg rounded-lg" type="text" placeholder="الاسم" required autoComplete="off" />
                                            <input id="phone" name="phone" defaultValue={editphone} onChange={(event) => seteditphone(event.target.value)} className="name text-right p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg rounded-lg" type="tel" placeholder="رقم الهاتف" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" required autoComplete="off" />


                                            <div className="text-center">
                                                <input id="price" name="price" defaultValue={editprice} onChange={(event) => seteditprice(event.target.value)} className="name w-32 p-2 mt-2 me-3  border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-blue-400 text-lg rounded-lg" type="number" placeholder="سعر" required autoComplete="off" />
                                                <input id="delevrprice" name="delevery" defaultValue={editpricedelv} onChange={(event) => seteditpricedelv(event.target.value)} className="name w-32 p-2 mt-2  border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-green-400 text-lg rounded-lg" type="number" placeholder="سعرالتوصيل" required autoComplete="off" />

                                            </div>


                                            <select name="state" defaultValue={editprovince_id} onChange={(event) => seteditprovince_id(event.target.value)} className="wilaya  text-black w-[265px] p-2 mt-2  border-solid border-2  border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg bg-gray-50 rounded-lg" id='judecheckout_state' required >
                                                <option value="jjj" disabled >   الولاية 👇</option>
                                                <option value='1'>01 Adrar - أدرار</option><option value='2'>02 Chlef - الشلف</option><option value='3'>03 Laghouat - الأغواط</option><option value='4'>04 Oum El Bouaghi - أم البواقي</option><option value='5'>05 Batna - باتنة</option><option value='6'>06 Béjaïa - بجاية</option><option value='7'>07 Biskra - بسكرة</option><option value='8'>08 Bechar - بشار</option><option value='9'>09 Blida - البليدة</option><option value='10'>10 Bouira - البويرة</option><option value='11'>11 Tamanrasset - تمنراست </option><option value='12'>12 Tébessa - تبسة </option><option value='13'>13 Tlemcene - تلمسان</option><option value='14'>14 Tiaret - تيارت</option><option value='15'>15 Tizi Ouzou - تيزي وزو</option><option value='16'>16 Alger - الجزائر</option><option value='17'>17 Djelfa - الجلفة</option><option value='18'>18 Jijel - جيجل</option><option value='19'>19 Sétif - سطيف</option><option value='20'>20 Saïda - سعيدة</option><option value='21'>21 Skikda - سكيكدة</option><option value='22'>22 Sidi Bel Abbès - سيدي بلعباس</option><option value='23'>23 Annaba - عنابة</option><option value='24'>24 Guelma - قالمة</option><option value='25'>25 Constantine - قسنطينة</option><option value='26'>26 Médéa - المدية</option><option value='27'>27 Mostaganem - مستغانم</option><option value='28'>28 MSila - مسيلة</option><option value='29'>29 Mascara - معسكر</option><option value='30'>30 Ouargla - ورقلة</option><option value='31'>31 Oran - وهران</option><option value='32'>32 El Bayadh - البيض</option><option value='33'>33 Illizi - إليزي </option><option value='34'>34 Bordj Bou Arreridj - برج بوعريريج</option><option value='35'>35 Boumerdès - بومرداس</option><option value='36'>36 El Tarf - الطارف</option><option value='37'>37 Tindouf - تندوف</option><option value='38'>38 Tissemsilt - تيسمسيلت</option><option value='39'>39 Eloued - الوادي</option><option value='40'>40 Khenchela - خنشلة</option><option value='41'>41 Souk Ahras - سوق أهراس</option><option value='42'>42 Tipaza - تيبازة</option><option value='43'>43 Mila - ميلة</option><option value='44'>44 Aïn Defla - عين الدفلى</option><option value='45'>45 Naâma - النعامة</option><option value='46'>46 Aïn Témouchent - عين تموشنت</option><option value='47'>47 Ghardaïa - غرداية</option><option value='48'>48 Relizane- غليزان</option><option value='49'>49 Timimoun - تيميمون</option><option value='50'>50 Bordj Baji Mokhtar - برج باجي مختار</option><option value='51'>51 Ouled Djellal - أولاد جلال</option><option value='52'>52 Béni Abbès -  بني عباس</option><option value='53'>53 Aïn Salah - عين صالح</option><option value='54'>54 In Guezzam - عين قزام</option><option value='55'>55 Touggourt - تقرت</option><option value='56'>56 Djanet - جانت</option><option value='57'>57 El MGhair - المغير</option><option value='58'>58 El Menia - المنيعة</option>
                                            </select>
                                            {/* <input id="adress" name="adress" defaultValue={"العنوان"} className="name p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg rounded-lg" type="text"/> */}
                                            <div className="flex justify-center py-2">
                                                <textarea id="adress" rows="3" defaultValue={editadress} onChange={(event) => seteditadress(event.target.value)} class="block  p-2.5 w-[265px] text-sm text-gray-900 bg-gray-50 rounded-lg border-2 border-gray-200 focus:ring-green-500 focus:border-green-500 focus:outline-none" placeholder="العنوان" />
                                            </div>
                                            <input id="exampleFormControlInput1" name="date" defaultValue={editdate} onChange={(event) => seteditdate(event.target.value)} className="name p-2 mt-2 border-solid border-2 border-gray-200 focus:border-green-600 focus:outline-none font-semibold text-lg rounded-lg" type="datetime-local" required autoComplete="off" />

                                        </div>
                                        <div className="mt-4 flex justify-between">
                                            <button
                                                type="button"
                                                className="inline-flex justify-center rounded-md border border-transparent bg-green-300 px-11 py-2 ms-11 text-sm font-medium text-white hover:bg-green-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                                                onClick={savemodel}
                                            >
                                                حفظ
                                            </button>
                                            <button
                                                type="button"
                                                className="inline-flex justify-center rounded-md border border-transparent bg-red-300 px-11 py-2  me-11 text-sm font-medium text-white hover:bg-red-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                                                onClick={closeModal}
                                            >
                                                إلغاء
                                            </button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition >

            </div >
        </>
    )


}
export default Orders;
